export type TitleType = "movie" | "tv" | "variety";

export interface SeasonInfo {
  season: number;
  episodeCount: number;
  note: string;
}

export interface Title {
  id: string;
  name: string;
  type: TitleType;
  cover: string;
  banner: string;
  rating: number;
  director: string;
  actors: string[];
  region: string;
  year: number;
  duration: string;
  genres: string[];
  summary: string;
  description: string;
  updateInfo: string;
  featured: boolean;
  seasons?: SeasonInfo[];
}

export const categories = [
  {
    type: "movie" as TitleType,
    label: "电影",
    desc: "院线大片与经典佳作，覆盖科幻、动作、爱情、悬疑多种题材",
    icon: "ri-film-line",
  },
  {
    type: "tv" as TitleType,
    label: "电视剧",
    desc: "大陆、港台、欧美、日韩热门剧集，更新不断追不停",
    icon: "ri-tv-2-line",
  },
  {
    type: "variety" as TitleType,
    label: "综艺",
    desc: "音乐、美食、旅行、竞技真人秀，轻松有趣的娱乐现场",
    icon: "ri-mic-line",
  },
];

export const regionOptions = ["全部", "大陆", "港台", "欧美", "日韩"];

export const decadeOptions = ["全部", "2020年代", "2010年代", "更早"];

export const sortOptions = [
  { key: "default", label: "综合排序" },
  { key: "hot", label: "按热度排序" },
  { key: "newest", label: "按最新上线排序" },
  { key: "rating", label: "按评分排序" },
];

export const titles: Title[] = [
  {
    id: "m1",
    name: "星际孤航",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20film%20poster%2C%20lone%20astronaut%20silhouette%20before%20a%20giant%20ringed%20planet%2C%20deep%20space%20nebula%2C%20dramatic%20teal%20and%20orange%20lighting%2C%20high%20detail%2C%20atmospheric%2C%20premium%20movie%20key%20art&width=400&height=600&seq=movie-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20space%20scene%2C%20vast%20starfield%20and%20glowing%20planet%20horizon%2C%20cinematic%20wide%20composition%2C%20moody%20lighting%20with%20warm%20and%20cool%20contrast%2C%20high%20detail%20film%20still&width=1600&height=900&seq=movie-banner-01&orientation=landscape",
    rating: 9.2,
    director: "陈牧",
    actors: ["林峯", "苏晴", "周澈"],
    region: "欧美",
    year: 2024,
    duration: "136分钟",
    genres: ["科幻", "冒险", "剧情"],
    summary: "一艘失联的星际飞船，一段跨越光年的孤独归途。",
    description: "在人类文明迈入深空殖民的时代，宇航员周澈奉命独自执行一次修复深空信标的常规任务，却因一场意外的引力扰动被抛入未知星域。飞船系统受损、通讯中断，他只能在有限资源下靠自己寻找回家的航路。旅途中他接收到一段来历不明的信号，逐渐揭开一场关于文明存续的隐秘计划。影片以冷峻的太空视觉与细腻的人物刻画，探讨了孤独、信念与人类在浩瀚宇宙中的渺小与坚韧。",
    updateInfo: "2024-09-12 上线",
    featured: true,
  },
  {
    id: "m2",
    name: "长安夜雨",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20historical%20Chinese%20film%20poster%2C%20rainy%20ancient%20capital%20city%20street%20at%20night%2C%20lantern%20glow%20reflecting%20on%20wet%20stone%2C%20elegant%20figure%20in%20flowing%20robe%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20high%20detail%20painterly&width=400&height=600&seq=movie-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20capital%20panorama%20under%20night%20rain%2C%20temple%20rooftops%20and%20glowing%20lanterns%2C%20misty%20atmosphere%2C%20cinematic%20wide%20shot%2C%20warm%20gold%20and%20cool%20shadow%20contrast%2C%20high%20detail&width=1600&height=900&seq=movie-banner-02&orientation=landscape",
    rating: 8.7,
    director: "沈知远",
    actors: ["顾清晏", "白祁", "许安"],
    region: "大陆",
    year: 2023,
    duration: "128分钟",
    genres: ["历史", "剧情", "悬疑"],
    summary: "一夜大雨，卷起盛唐长安城下隐藏多年的旧案。",
    description: "盛唐年间，长安城一场连绵三日的大雨冲开了一桩沉寂多年的旧案。负责查案的年轻少卿在层层线索中，发现案件竟与朝堂之上的一股暗流息息相关。随着真相逐步浮现，他不得不在家族、正义与生死之间做出抉择。影片以考究的美术与克制的叙事，还原了一个风云暗涌的长安之夜。",
    updateInfo: "2023-11-03 上线",
    featured: true,
  },
  {
    id: "m3",
    name: "深海回声",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20thriller%20film%20poster%2C%20deep%20ocean%20submarine%20window%20with%20faint%20light%2C%20eerie%20underwater%20depths%2C%20cold%20teal%20palette%20with%20single%20warm%20glow%2C%20high%20detail%20suspense%20mood&width=400&height=600&seq=movie-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=deep%20sea%20underwater%20trench%20scene%20with%20dim%20light%20beams%2C%20submersible%20silhouette%2C%20cinematic%20wide%20composition%2C%20cold%20blue%20tones%20with%20soft%20warm%20highlight%2C%20high%20detail&width=1600&height=900&seq=movie-banner-03&orientation=landscape",
    rating: 8.1,
    director: "David Lang",
    actors: ["Ethan Cole", "Mia Ross", "Noah Blake"],
    region: "欧美",
    year: 2022,
    duration: "118分钟",
    genres: ["惊悚", "悬疑", "科幻"],
    summary: "深海之中，一段无法解释的回声不断召唤着考察队。",
    description: "一支国际海洋科考队前往太平洋最深处执行地质勘探任务，却在无人抵达过的海沟里录到一段规律而诡异的回声。随着下潜深度不断增加，队员们的记忆与判断开始出现偏差，彼此之间的信任也被逐渐侵蚀。真相究竟是科学的意外，还是深海本身在回应他们的到来？",
    updateInfo: "2022-07-19 上线",
    featured: false,
  },
  {
    id: "m4",
    name: "追风者",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=action%20film%20poster%2C%20street%20racer%20on%20a%20sport%20motorcycle%20under%20city%20highway%20lights%2C%20motion%20blur%2C%20dynamic%20angle%2C%20orange%20and%20dark%20grey%20tone%2C%20high%20detail%20energetic&width=400&height=600&seq=movie-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=night%20city%20highway%20chase%20scene%20with%20light%20trails%2C%20motorcycle%20rider%20silhouette%2C%20cinematic%20dynamic%20composition%2C%20orange%20glow%20against%20dark%20grey%2C%20high%20detail&width=1600&height=900&seq=movie-banner-04&orientation=landscape",
    rating: 7.8,
    director: "麦家良",
    actors: ["郑亦风", "方晴", "黄立"],
    region: "港台",
    year: 2021,
    duration: "110分钟",
    genres: ["动作", "犯罪"],
    summary: "一名退役车手为找回真相，重回车水马龙的街头。",
    description: "退役多年的街头车手郑亦风因弟弟意外身亡被迫重回赛场。在追查真相的过程中，他卷入了地下赛车与走私集团的纷争。引擎轰鸣之间，他必须用最擅长的方式，在城市的霓虹与夜色里博出一线生机。",
    updateInfo: "2021-05-28 上线",
    featured: false,
  },
  {
    id: "m5",
    name: "樱之彼岸",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=romantic%20film%20poster%2C%20cherry%20blossom%20avenue%20with%20two%20distant%20figures%2C%20soft%20spring%20light%2C%20gentle%20pink%20and%20warm%20cream%20tones%2C%20high%20detail%20tender%20mood&width=400&height=600&seq=movie-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=cherry%20blossom%20path%20along%20a%20quiet%20river%20at%20dusk%2C%20petals%20in%20the%20air%2C%20cinematic%20wide%20composition%2C%20soft%20pink%20and%20muted%20gold%20light%2C%20high%20detail%20romantic&width=1600&height=900&seq=movie-banner-05&orientation=landscape",
    rating: 8.4,
    director: "小野遥",
    actors: ["宫崎葵", "佐藤彻", "森川玲"],
    region: "日韩",
    year: 2023,
    duration: "121分钟",
    genres: ["爱情", "剧情"],
    summary: "两个错过又重逢的人，在樱花落尽的季节说出心里话。",
    description: "高中时代相识的两人因一场误会各奔东西，多年后在故乡的樱花道旁意外重逢。随着记忆一点点被打开，那些未能说出口的话与未完成的告别，都在这个春天有了答案。影片用细腻克制的镜头，讲述了一段关于遗憾与释怀的温柔故事。",
    updateInfo: "2023-04-06 上线",
    featured: true,
  },
  {
    id: "m6",
    name: "迷失东京塔",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=mystery%20film%20poster%2C%20tall%20city%20tower%20glowing%20at%20night%20above%20dense%20metropolis%2C%20neon%20reflections%2C%20cool%20violet%20and%20deep%20blue%20tones%2C%20high%20detail%20noir%20mood&width=400&height=600&seq=movie-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=night%20metropolis%20skyline%20with%20a%20tall%20illuminated%20tower%2C%20dense%20neon%20city%20below%2C%20cinematic%20wide%20composition%2C%20cool%20blue%20and%20magenta%20glow%2C%20high%20detail&width=1600&height=900&seq=movie-banner-06&orientation=landscape",
    rating: 7.5,
    director: "北野诚",
    actors: ["藤原浩", "石原理惠", "田中悠"],
    region: "日韩",
    year: 2020,
    duration: "107分钟",
    genres: ["悬疑", "剧情"],
    summary: "一名记者在东京塔下追踪一桩离奇的失踪案。",
    description: "自由记者藤原浩接到一桩关于连环失踪的匿名线索，线索全部指向城市中心那座沉默的塔。随着调查深入，他发现自己也被卷入了这场没有答案的迷局。城市越繁华，人心越难测，真相或许就藏在他一直视而不见的地方。",
    updateInfo: "2020-10-15 上线",
    featured: false,
  },
  {
    id: "m7",
    name: "荒野信标",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=adventure%20film%20poster%2C%20lone%20hiker%20on%20a%20vast%20mountain%20ridge%20at%20sunrise%2C%20dramatic%20clouds%2C%20warm%20gold%20light%20against%20cool%20grey%20rock%2C%20high%20detail%20cinematic&width=400&height=600&seq=movie-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=sweeping%20mountain%20wilderness%20panorama%20at%20dawn%2C%20tiny%20traveler%20and%20signal%20beacon%20on%20a%20cliff%2C%20cinematic%20wide%20shot%2C%20warm%20sunrise%20and%20cool%20shadow%2C%20high%20detail&width=1600&height=900&seq=movie-banner-07&orientation=landscape",
    rating: 8.9,
    director: "Sarah Nolan",
    actors: ["Liam Ford", "Ava Hayes", "Owen Reed"],
    region: "欧美",
    year: 2024,
    duration: "132分钟",
    genres: ["冒险", "剧情"],
    summary: "为寻找失踪的队友，他独自踏入无人区点亮信标。",
    description: "一次登山队意外让资深向导失去了同伴。为了寻找失踪的队友，他独自深入无人涉足的荒野，在极端天气与未知地形中与时间赛跑。当所有希望逐渐渺茫，一个微弱的信号成为他坚持下去的唯一理由。影片以震撼的自然景观与真实的情感力量打动人心。",
    updateInfo: "2024-06-21 上线",
    featured: true,
  },
  {
    id: "m8",
    name: "无声之城",
    type: "movie",
    cover: "https://readdy.ai/api/search-image?query=crime%20drama%20film%20poster%2C%20empty%20foggy%20city%20street%20at%20night%2C%20single%20detective%20figure%20with%20coat%2C%20muted%20grey%20and%20amber%20streetlight%2C%20high%20detail%20noir%20atmosphere&width=400&height=600&seq=movie-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=foggy%20empty%20city%20avenue%20at%20night%20with%20streetlights%2C%20distant%20silhouette%2C%20cinematic%20wide%20composition%2C%20muted%20grey%20with%20warm%20amber%20glow%2C%20high%20detail&width=1600&height=900&seq=movie-banner-08&orientation=landscape",
    rating: 8.0,
    director: "韩松",
    actors: ["梁正", "宋雅", "崔明"],
    region: "大陆",
    year: 2022,
    duration: "115分钟",
    genres: ["犯罪", "悬疑"],
    summary: "一座突然陷入沉默的城市，藏着没人愿意提起的秘密。",
    description: "接连发生的案件让城市陷入不安，一名坚持追查的老刑警发现所有线索都指向同一家早已倒闭的工厂。随着真相逼近，沉默的城墙开始裂开缝隙。影片以冷峻的影像风格，呈现了一场关于正义与代价的角力。",
    updateInfo: "2022-12-09 上线",
    featured: false,
  },
  {
    id: "t1",
    name: "迷雾都市",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=crime%20series%20poster%2C%20rainy%20city%20skyline%20at%20night%20with%20a%20lone%20detective%20silhouette%2C%20teal%20and%20amber%20lighting%2C%20moody%20fog%2C%20high%20detail%20cinematic%20key%20art&width=400&height=600&seq=tv-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=rainy%20metropolis%20at%20night%20with%20wet%20streets%20and%20neon%20signs%2C%20distant%20figure%20under%20an%20umbrella%2C%20cinematic%20wide%20composition%2C%20teal%20and%20amber%20tone%2C%20high%20detail&width=1600&height=900&seq=tv-banner-01&orientation=landscape",
    rating: 9.0,
    director: "陆川行",
    actors: ["秦岚", "高博", "姜黎"],
    region: "大陆",
    year: 2024,
    duration: "更新至 24 集",
    genres: ["悬疑", "犯罪", "剧情"],
    summary: "连续失踪案的背后，是一座城市不愿醒来的迷雾。",
    description: "一起看似普通的失踪案，牵出了这座城市盘根错节的利益网络。刑警与记者两条线索交叉推进，真相在层层迷雾中若隐若现。剧集以扎实的剧本与紧凑的节奏，勾勒出都市众生相与人性幽微之处。",
    updateInfo: "每周三更新 2 集",
    featured: true,
    seasons: [
      { season: 1, episodeCount: 24, note: "第一季 · 全集" },
      { season: 2, episodeCount: 8, note: "第二季 · 更新中" },
    ],
  },
  {
    id: "t2",
    name: "山海纪年",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=fantasy%20epic%20series%20poster%2C%20mythical%20mountains%20and%20sea%20with%20celestial%20light%2C%20ancient%20hero%20silhouette%2C%20rich%20jade%20green%20and%20gold%20tones%2C%20high%20detail%20painterly&width=400&height=600&seq=tv-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=mythical%20landscape%20of%20floating%20mountains%20above%20a%20misty%20sea%2C%20celestial%20glow%2C%20cinematic%20wide%20composition%2C%20jade%20green%20and%20warm%20gold%2C%20high%20detail%20fantasy&width=1600&height=900&seq=tv-banner-02&orientation=landscape",
    rating: 8.6,
    director: "云舒",
    actors: ["唐棠", "纪白", "宋珧"],
    region: "大陆",
    year: 2023,
    duration: "更新至 40 集",
    genres: ["奇幻", "古装", "冒险"],
    summary: "山海之间，一场跨越千年的约定正在苏醒。",
    description: "上古山海异兽的传说在少年身上重现，他被迫踏上寻找真相的旅程。旅途中结识的伙伴各怀心事，山海之间的秘密也逐渐浮出水面。剧集以宏大的世界观与精美的美术设计，构建了一个瑰丽的东方奇幻世界。",
    updateInfo: "每日 20:00 更新",
    featured: true,
    seasons: [{ season: 1, episodeCount: 40, note: "第一季 · 全集" }],
  },
  {
    id: "t3",
    name: "白塔之上",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=drama%20series%20poster%2C%20lonely%20white%20lighthouse%20on%20a%20cliff%20by%20the%20sea%2C%20soft%20overcast%20light%2C%20muted%20grey%20and%20warm%20cream%20tones%2C%20high%20detail%20melancholic&width=400&height=600&seq=tv-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=white%20lighthouse%20on%20a%20rocky%20coast%20at%20dusk%2C%20calm%20sea%20and%20overcast%20sky%2C%20cinematic%20wide%20shot%2C%20muted%20grey%20and%20soft%20gold%2C%20high%20detail&width=1600&height=900&seq=tv-banner-03&orientation=landscape",
    rating: 8.2,
    director: "麦宝仪",
    actors: ["陈嘉", "林孟", "何家俊"],
    region: "港台",
    year: 2022,
    duration: "全 30 集",
    genres: ["剧情", "家庭"],
    summary: "一座海边白塔，见证一个家族三代人的聚散离合。",
    description: "故事围绕守塔人一家三代展开，从渔村到都市，从离别到重逢。白塔静静矗立，像是一个沉默的见证者。剧集以细腻的笔触描绘时代变迁下普通人的命运，情感真挚动人。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 30, note: "第一季 · 全集" }],
  },
  {
    id: "t4",
    name: "硅谷幻梦",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=tech%20drama%20series%20poster%2C%20modern%20office%20glass%20building%20at%20night%20with%20glowing%20screens%2C%20cool%20blue%20and%20warm%20accent%20light%2C%20high%20detail%20clean%20aesthetic&width=400&height=600&seq=tv-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=modern%20tech%20campus%20with%20glass%20towers%20at%20dusk%2C%20warm%20interior%20lights%2C%20cinematic%20wide%20composition%2C%20cool%20blue%20with%20warm%20accents%2C%20high%20detail&width=1600&height=900&seq=tv-banner-04&orientation=landscape",
    rating: 7.9,
    director: "Daniel Kim",
    actors: ["Ryan Park", "Emily Stone", "Chris Vale"],
    region: "欧美",
    year: 2021,
    duration: "全 18 集",
    genres: ["剧情", "商战"],
    summary: "一群年轻人想在科技浪潮里造出改变世界的产品。",
    description: "几位背景各异的年轻人共同创办了一家初创公司，梦想在科技浪潮中站稳脚跟。融资、竞争、背叛与理想主义交织，让他们不断面对选择的代价。剧集以犀利又幽默的方式，呈现了创业世界的真实与荒诞。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 18, note: "第一季 · 全集" }],
  },
  {
    id: "t5",
    name: "江户物语",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=historical%20Japanese%20series%20poster%2C%20edo%20period%20town%20street%20with%20wooden%20houses%20and%20lanterns%2C%20soft%20evening%20light%2C%20warm%20earthy%20tones%2C%20high%20detail%20painterly&width=400&height=600&seq=tv-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=edo%20era%20japanese%20town%20panorama%20with%20wooden%20buildings%20and%20paper%20lanterns%2C%20dusk%20light%2C%20cinematic%20wide%20composition%2C%20warm%20earthy%20tones%2C%20high%20detail&width=1600&height=900&seq=tv-banner-05&orientation=landscape",
    rating: 8.8,
    director: "小林靖",
    actors: ["松田优", "桥本奈", "山口健"],
    region: "日韩",
    year: 2023,
    duration: "全 26 集",
    genres: ["历史", "剧情"],
    summary: "江户城中一位普通匠人的日常，也是大时代的缩影。",
    description: "故事跟随江户城中的一位木匠展开，他在平凡的日子里见证着时代的流转与市井的烟火。每一次修缮、每一场相逢，都藏着生活的重量。剧集以考究的细节与娓娓道来的叙事，还原了一个鲜活的时代。",
    updateInfo: "已完结",
    featured: true,
    seasons: [{ season: 1, episodeCount: 26, note: "第一季 · 全集" }],
  },
  {
    id: "t6",
    name: "紧急救援",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%2C%20emergency%20room%20with%20blurred%20lights%20and%20medical%20staff%2C%20clean%20white%20and%20teal%20tones%20with%20warm%20accent%2C%20high%20detail%20tense%20mood&width=400&height=600&seq=tv-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=modern%20hospital%20corridor%20with%20bright%20lights%20and%20medical%20team%20in%20motion%2C%20cinematic%20wide%20composition%2C%20clean%20white%20and%20teal%20with%20warm%20highlights%2C%20high%20detail&width=1600&height=900&seq=tv-banner-06&orientation=landscape",
    rating: 8.3,
    director: "苏铭",
    actors: ["赵宁", "许蕾", "谭峰"],
    region: "大陆",
    year: 2024,
    duration: "更新至 16 集",
    genres: ["剧情", "职业"],
    summary: "急诊室里，每一分钟都关乎生死与人心。",
    description: "一群急诊科医护人员在高强度的工作中与时间赛跑。每一次抢救不仅是技术的考验，更是人性与情感的碰撞。剧集以真实专业的医疗场景与饱满的人物群像，致敬每一位守护生命的人。",
    updateInfo: "每周五更新 2 集",
    featured: false,
    seasons: [{ season: 1, episodeCount: 16, note: "第一季 · 更新中" }],
  },
  {
    id: "t7",
    name: "暗流",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=spy%20thriller%20series%20poster%2C%20lone%20figure%20in%20a%20trench%20coat%20on%20a%20rainy%20old%20city%20street%2C%20dim%20amber%20lamplight%2C%20muted%20grey%20and%20deep%20green%2C%20high%20detail%20noir&width=400&height=600&seq=tv-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=old%20city%20street%20at%20dusk%20in%20light%20rain%2C%20vintage%20buildings%20and%20dim%20lamps%2C%20cinematic%20wide%20composition%2C%20muted%20grey%20and%20amber%2C%20high%20detail%20noir&width=1600&height=900&seq=tv-banner-07&orientation=landscape",
    rating: 8.5,
    director: "闻朔",
    actors: ["沈阳", "白夏", "程野"],
    region: "大陆",
    year: 2022,
    duration: "全 32 集",
    genres: ["谍战", "悬疑"],
    summary: "平静的水面之下，暗流从未停止涌动。",
    description: "动荡年代里，一位潜伏者游走在敌我之间，用一次次看似平常的对话传递关键情报。身份、信仰与情感不断撕扯着他，每一步都可能是最后一步。剧集以缜密的悬念布局与克制的情感表达，讲述了一段无名英雄的故事。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 32, note: "第一季 · 全集" }],
  },
  {
    id: "t8",
    name: "星际殖民局",
    type: "tv",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20series%20poster%2C%20colony%20domes%20on%20an%20alien%20red%20planet%2C%20two%20moons%20in%20the%20sky%2C%20cool%20blue%20with%20warm%20orange%20dust%2C%20high%20detail%20cinematic&width=400&height=600&seq=tv-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=alien%20planet%20colony%20panorama%20with%20domed%20settlements%20and%20red%20dust%20horizon%2C%20cinematic%20wide%20composition%2C%20cool%20blue%20sky%20with%20warm%20orange%20ground%2C%20high%20detail&width=1600&height=900&seq=tv-banner-08&orientation=landscape",
    rating: 8.1,
    director: "Grace Bell",
    actors: ["Alex Reed", "Nina Cole", "Sam Ortiz"],
    region: "欧美",
    year: 2024,
    duration: "更新至 10 集",
    genres: ["科幻", "剧情"],
    summary: "在异星殖民地上，人类的秩序正面临全新考验。",
    description: "首批殖民者在异星建立起脆弱的定居点，资源、规则与人性在这里被重新定义。当来自地球的指令与殖民地现实产生冲突，管理者必须在原则与生存之间做出抉择。剧集以硬核的设定与群像叙事，探讨文明的边界。",
    updateInfo: "每周日更新 1 集",
    featured: false,
    seasons: [{ season: 1, episodeCount: 10, note: "第一季 · 更新中" }],
  },
  {
    id: "v1",
    name: "蘑菇音乐节",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=music%20festival%20show%20poster%2C%20energetic%20outdoor%20stage%20with%20crowd%20and%20stage%20lights%2C%20vibrant%20orange%20and%20magenta%20glow%2C%20high%20detail%20festive%20mood&width=400&height=600&seq=variety-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=large%20outdoor%20music%20festival%20stage%20at%20night%20with%20lights%20and%20crowd%2C%20cinematic%20wide%20composition%2C%20vibrant%20orange%20and%20magenta%2C%20high%20detail%20energetic&width=1600&height=900&seq=variety-banner-01&orientation=landscape",
    rating: 8.4,
    director: "总导演 · 何燃",
    actors: ["蘑菇乐队", "特邀嘉宾"],
    region: "大陆",
    year: 2024,
    duration: "更新至 8 期",
    genres: ["音乐", "舞台"],
    summary: "一场属于年轻人的夏日音乐现场，燃爆整个舞台。",
    description: "蘑菇音乐节汇集了来自各地的乐队与独立音乐人，用最真诚的现场演出点燃夏天。每一期都有不同主题的舞台挑战与跨界合作，让观众感受音乐最纯粹的力量。",
    updateInfo: "每周六 20:00 更新",
    featured: true,
    seasons: [{ season: 1, episodeCount: 8, note: "第一季 · 更新中" }],
  },
  {
    id: "v2",
    name: "极限厨房",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=cooking%20show%20poster%2C%20chef%20plating%20a%20dish%20in%20a%20busy%20modern%20kitchen%2C%20warm%20appetizing%20golden%20light%2C%20high%20detail%20vibrant%20food%20photography&width=400&height=600&seq=variety-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=modern%20open%20kitchen%20with%20chefs%20cooking%20under%20warm%20lights%2C%20steam%20and%20fresh%20ingredients%2C%20cinematic%20wide%20composition%2C%20warm%20golden%20tones%2C%20high%20detail&width=1600&height=900&seq=variety-banner-02&orientation=landscape",
    rating: 7.7,
    director: "总导演 · 姜味",
    actors: ["明星厨师团"],
    region: "大陆",
    year: 2023,
    duration: "全 12 期",
    genres: ["美食", "竞技"],
    summary: "限时挑战与神秘食材，看厨师们如何化平凡为惊艳。",
    description: "每一期节目都会给出意想不到的食材与苛刻的限时挑战，厨师们必须在压力之下呈现餐盘上的惊喜。美食之外，更是创意、经验与心态的较量。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 12, note: "第一季 · 全集" }],
  },
  {
    id: "v3",
    name: "环游地球80天",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=travel%20show%20poster%2C%20traveler%20with%20backpack%20overlooking%20a%20scenic%20coastal%20town%2C%20bright%20daylight%2C%20warm%20and%20cool%20balanced%20tones%2C%20high%20detail%20adventurous&width=400&height=600&seq=variety-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=sweeping%20travel%20scenery%20of%20coastal%20town%20and%20mountains%2C%20sunny%20sky%2C%20cinematic%20wide%20composition%2C%20warm%20gold%20and%20cool%20blue%2C%20high%20detail&width=1600&height=900&seq=variety-banner-03&orientation=landscape",
    rating: 8.0,
    director: "总导演 · 路遥",
    actors: ["旅行团成员"],
    region: "大陆",
    year: 2023,
    duration: "全 10 期",
    genres: ["旅行", "纪实"],
    summary: "用自己的方式，在有限时间里走完一段不可思议的旅程。",
    description: "嘉宾们带着有限的预算与装备出发，用各种意想不到的方式抵达目的地。旅途中的意外、相遇与成长，构成了最真实的风景。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 10, note: "第一季 · 全集" }],
  },
  {
    id: "v4",
    name: "星赛道场",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=racing%20competition%20show%20poster%2C%20go-kart%20racers%20on%20a%20lit%20night%20track%2C%20motion%20blur%20and%20sparks%2C%20orange%20and%20dark%20grey%20tones%2C%20high%20detail%20high%20energy&width=400&height=600&seq=variety-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=illuminated%20night%20racing%20track%20with%20karts%20in%20motion%2C%20light%20trails%2C%20cinematic%20wide%20composition%2C%20orange%20glow%20against%20dark%20grey%2C%20high%20detail&width=1600&height=900&seq=variety-banner-04&orientation=landscape",
    rating: 7.4,
    director: "总导演 · 赵驰",
    actors: ["竞速嘉宾团"],
    region: "大陆",
    year: 2022,
    duration: "全 12 期",
    genres: ["竞技", "真人秀"],
    summary: "速度与技术的正面碰撞，冠军只有一个。",
    description: "来自不同领域的嘉宾站上同一条赛道，用驾驶技术与心理素质一决高下。每一场对决都充满变数，胜负往往在毫秒之间。",
    updateInfo: "已完结",
    featured: false,
    seasons: [{ season: 1, episodeCount: 12, note: "第一季 · 全集" }],
  },
  {
    id: "v5",
    name: "深夜脱口秀",
    type: "variety",
    cover: "https://readdy.ai/api/search-image?query=talk%20show%20poster%2C%20stylish%20host%20on%20a%20warm%20lit%20stage%20with%20audience%20silhouettes%2C%20rich%20amber%20and%20deep%20maroon%20tones%2C%20high%20detail%20elegant&width=400&height=600&seq=variety-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=elegant%20talk%20show%20stage%20with%20warm%20lights%20and%20audience%20seats%2C%20cinematic%20wide%20composition%2C%20rich%20amber%20and%20deep%20maroon%2C%20high%20detail&width=1600&height=900&seq=variety-banner-05&orientation=landscape",
    rating: 8.2,
    director: "总导演 · 麦子",
    actors: ["主持团", "特邀嘉宾"],
    region: "港台",
    year: 2024,
    duration: "更新至 20 期",
    genres: ["脱口秀", "访谈"],
    summary: "深夜时分，用笑声聊聊生活里那些真实的小事。",
    description: "节目邀请来自不同领域的嘉宾围坐一桌，从生活琐事聊到社会话题，用幽默与真诚化解疲惫。每一期都像一场不设防的深夜对话。",
    updateInfo: "每周四 22:00 更新",
    featured: true,
    seasons: [{ season: 1, episodeCount: 20, note: "第一季 · 更新中" }],
  },
];